module.exports = __webpack_public_path__ + "static/img/dy_code.1e5f7816.png";